import { Link, useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import { Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FaPlus, FaTimes, FaEdit, FaCheck } from 'react-icons/fa';
import { useAdminReadAllUsersQuery } from '../../slices/usersApiSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Paginate from '../../components/Paginate';


export default function ReadAllUsersDeleteUserScreen() {
  const { pageNumber } = useParams();
  const page = pageNumber || 1;

  const { userInfo } = useSelector((state) => state.auth);
  
  const { data, isLoading, error } = useAdminReadAllUsersQuery(
    userInfo
      ? { adminId: userInfo._id, page }
      : skipToken
  );

  if (!userInfo) return <Loader />;

  const renderError = (error) => {
    if (!error) return '';
    if (typeof error === 'string') return error;
    if (error.data && error.data.message) return error.data.message;
    if (error.error) return error.error;
    try {
      return JSON.stringify(error);
    } catch {
      return String(error);
    }
  };

  return (
    <>
      <div style={{ marginTop: '32px', marginBottom: '16px' }}>
        <h1 style={{ marginBottom: '16px' }}>All Users</h1>
        <div className='d-flex justify-content-between align-items-center'>
          <Link to={`/admin/home`} className='btn btn-light text-decoration-none'>
            Cancel
          </Link>
          <Link
            to={`/admin/all_users/add_user`}
            className='btn btn-primary d-flex align-items-center'
          >
            <FaPlus />&nbsp;Add New User
          </Link>
        </div>
      </div>
      {isLoading ? (
        <Loader /> 
      ) : error ? (
        <Message variant='danger'>{renderError(error)}</Message> 
      ) : (
          <div
            className='shadow-sm'
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
              border: '1px solid var(--card-bc)',
              backgroundColor: 'var(--card-bg)',
              padding: '16px',
            }}
          >
          <Table
            striped
            hover
            responsive
            className='table-sm mb-0 table--admin-users'
          >
            <thead>
              <tr>
                <th>FIRST NAME</th>
                <th>LAST NAME</th>
                <th>PRIMARY E-MAIL</th>
                <th>ADMIN</th>
                <th>CREATED</th>
                <th>VERIFIED</th>
                <th>EDIT</th>
              </tr>
            </thead>
            <tbody>
              {data.users.map((user) => ( 
                <tr key={user._id}>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>
                    <a href={`mailto:${user.primaryEmail || user.secondaryEmail}`}>
                      { user.primaryEmail || user.secondaryEmail }
                    </a>
                  </td>
                  <td>
                    {user.isAdmin ? ( 
                      <FaCheck style={{ color: 'green' }} />
                    ) : ( 
                      <FaTimes style={{ color: 'red' }} />
                    )}
                  </td>
                  <td>
                    {user.createdAt
                      ? new Date(user.createdAt).toLocaleDateString()
                      : '—'}
                  </td>
                  <td>
                    {user.isVerified ? ( 
                      <FaCheck style={{ color: 'green' }} />
                    ) : ( 
                      <FaTimes style={{ color: 'red' }} />
                    )}
                  </td>
                  <td>
                    <Link to={`/admin/all_users/user/${user._id}/edit_user`} className='btn btn-light btn-sm text-decoration-none'>
                      <FaEdit />
                    </Link>
                  </td>
                </tr>
              )) }
            </tbody>
          </Table>
          </div>
        )
      }
      <div style={{ margin: '32px 0' }}>
        <Paginate 
          totalPages={data?.totalPages} 
          currentPage={data?.currentPage} 
          basePath={`/admin/all_users`} 
          firstPageIsBasePath={true}
        />
      </div>

    </>
  );
};